import {
  eventBus
} from '../eventbus'
import iziToast from 'izitoast';

export default {
  data: function () {
    return {}
  },
  mounted: function () {
    //override defaults options
    iziToast.settings({
      timeout: 10000
    });

  },
  methods: {
    simpleNotification: function (type, options) {
      if (options.title == "DEV") {
        options.timeout = 4000;
        options.progressBar = false;
      }
      options["pauseOnHover"] = false;
      var prod = true;
      if (options.title != "DEV" || !prod) {
        switch (type) {
          case 'info':
            iziToast.info(options)
            break;
          case 'success':
            iziToast.success(options)
            break;
          case 'warning':
            iziToast.warning(options)
            break;
          case 'error':
            iziToast.error(options)
            break;
        }
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/notification_mixin.js